import get from "lodash.get";
import CustomAnalysisUtils from "./utils";
import CustomAnalysisActionTypes from "./types";
import CustomAnalysisActioner from "./actioner";

const CustomAnalysisMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState);
    }
    if (action.type === CustomAnalysisActionTypes.SET_ATTENDANCE_FILTERS) {
      next(action);

      const withComparison = get(
        getState().CustomAnalysis,
        "filters.withComparison"
      );
      const data = CustomAnalysisUtils.getBodyFromStateAndType(
        getState(),
        "analysis"
      );
      dispatch(
        CustomAnalysisActioner.retrieveAttendanceGraph("analysis", data)
      );

      if (withComparison) {
        const comparedData = CustomAnalysisUtils.getBodyFromStateAndType(
          getState(),
          "compared"
        );
        dispatch(
          CustomAnalysisActioner.retrieveAttendanceGraph(
            "compared",
            comparedData
          )
        );
      }

      return;
    }
    if (action.type === CustomAnalysisActionTypes.SET_ATTENDANCE_PEAK_FILTERS) {
      next(action);

      const withComparison = get(
        getState().CustomAnalysis,
        "filters.withComparison"
      );
      const data = CustomAnalysisUtils.getBodyFromStateAndType(
        getState(),
        "analysis"
      );
      dispatch(
        CustomAnalysisActioner.retrieveAttendancePeakData("analysis", data)
      );

      if (withComparison) {
        const comparedData = CustomAnalysisUtils.getBodyFromStateAndType(
          getState(),
          "compared"
        );
        dispatch(
          CustomAnalysisActioner.retrieveAttendancePeakData(
            "compared",
            comparedData
          )
        );
      }

      return;
    }
    if (
      action.type === CustomAnalysisActionTypes.SET_HOURLY_ATTENDANCE_FILTERS
    ) {
      next(action);

      const withComparison = get(
        getState().CustomAnalysis,
        "filters.withComparison"
      );
      const data = CustomAnalysisUtils.getBodyFromStateAndType(
        getState(),
        "analysis"
      );
      dispatch(
        CustomAnalysisActioner.retrieveHourlyAttendanceByDayOfWeek(
          "analysis",
          data
        )
      );

      if (withComparison) {
        const comparedData = CustomAnalysisUtils.getBodyFromStateAndType(
          getState(),
          "compared"
        );
        dispatch(
          CustomAnalysisActioner.retrieveHourlyAttendanceByDayOfWeek(
            "compared",
            comparedData
          )
        );
      }

      return;
    }

    return next(action);
  };

export default CustomAnalysisMiddleware;
